import React from 'react';
import { Link } from 'react-router-dom';
import {  FiGithub, FiTwitter, FiLinkedin, FiMail } from 'react-icons/fi';
import { FaTrain } from 'react-icons/fa'; // from Font Awesome

import styles from './Footer.module.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.footerContainer}`}>
        {/* Top Section */}
        <div className={styles.topSection}>
          {/* Brand */}
          <div className={styles.brandSection}>
            <div className={styles.logo}>
              <FaTrain className={styles.logoIcon} />
              <span className={styles.logoText}>RailTracker</span>
            </div>
            <p className={styles.description}>
              Your trusted companion for real-time train status and PNR checking.
              Fast, reliable, and always up-to-date.
            </p>
            <div className={styles.socialLinks}>
              <a href="https://github.com/shivangjoshii" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
                <FiGithub />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
                <FiTwitter />
              </a>
              <a href="https://linkedin.com/in/mrpwan01" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
                <FiLinkedin />
              </a>
              <a href="mailto:ceo@cozyo.in" className={styles.socialLink}>
                <FiMail />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className={styles.linksSection}>
            <h3 className={styles.linksTitle}>Quick Links</h3>
            <ul className={styles.linksList}>
              <li><Link to="/" className={styles.link}>Home</Link></li>
              <li><Link to="/pnr-status" className={styles.link}>PNR Status</Link></li>
              <li><Link to="/train-status" className={styles.link}>Live Train Status</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div className={styles.linksSection}>
            <h3 className={styles.linksTitle}>Resources</h3>
            <ul className={styles.linksList}>
              <li><a href="#" className={styles.link}>About Us</a></li>
              <li><a href="#" className={styles.link}>FAQ</a></li>
              <li><a href="#" className={styles.link}>Contact</a></li>
              <li><a href="#" className={styles.link}>Privacy Policy</a></li>
            </ul>
          </div>

          {/* Support */}
          <div className={styles.linksSection}>
            <h3 className={styles.linksTitle}>Support</h3>
            <ul className={styles.linksList}>
              <li><a href="#" className={styles.link}>Help Center</a></li>
              <li><a href="#" className={styles.link}>Terms of Service</a></li>
              <li><a href="#" className={styles.link}>Report Issue</a></li>
              <li><a href="#" className={styles.link}>API Documentation</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className={styles.bottomSection}>
          <p className={styles.copyright}>
            © {currentYear} RailTracker. Crafted with ❤️ by <a href="https://mrpawan.netlify.app" target="_blank" rel="noopener noreferrer" className={styles.authorLink}>Pawan Kumar</a>
          </p>
          <p className={styles.disclaimer}>
            Data provided by Indian Railways. For official information, please visit IRCTC.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;